import { computed } from "vue";
import { DsNotifier } from "../helpers";
import i18n from "../i18n";
import { useDsApiStore, useDsSystemNotifierStore } from "../stores";

export const useDsConnectivity = () => {
  const apiStore = useDsApiStore();
  const systemNotifierStore = useDsSystemNotifierStore();
  const isOnline = computed(() => apiStore.online);

  const setOnline = () => {
    apiStore.setOnline();
    DsNotifier.delete(systemNotifierStore.connectivityNotificationId);
    systemNotifierStore.setConnectivityId(0);
  };

  const setOffline = () => {
    apiStore.setOffline();
    if (systemNotifierStore.connectivityNotificationId === 0) {
      const id = DsNotifier.sendWarning({
        // TODO: Convert to use the useI18n hook later once the API service has been migrated.
        message: i18n.global.t("ds.composable.connectivity.error"),
        duration: 0,
        enableClose: false,
        position: "top-0 right-0",
        overlay: true,
      });
      systemNotifierStore.setConnectivityId(id);
    }
  };
  return {
    isOnline,
    setOnline,
    setOffline,
  };
};
